<template>
  <div class="weapons-v2">
    <div class="weapons-v2__top-wrapper">
      <div class="image-wrapper">
        <img
          :alt="title"
          :src="getImageFromWaxpeer(weapon.full_name || '', '500:500')"
          class="weapons-v2-card__image"
          loading="eager"
        >
      </div>
      <div class="weapons-v2__info">
        <h1 class="weapons-v2__info-title">
          {{ title }}
        </h1>
        <p class="weapons-v2__info-desc">
          <!--          {{ -->
          <!--            currW <= 525 && !toggle ? -->
          <!--                t(`weapon_page_title`, {name: t('filters.weapon.' + weapon?.weapon)}).slice(0, 115) + '...' : -->
          <!--                t(`weapon_page_title`, {name: t('filters.weapon.' + weapon?.weapon)}) -->
          <!--          }} -->
          <!--          <button class="white btn btn-link" @click="toggle = !toggle"> -->
          <!--            {{ toggle ? t('show_less') : t('show_more') }} -->
          <!--          </button> -->
          <!--          {{ t('agents_description') }} -->
        </p>{{ subTitle }}
      </div>
    </div>

    <div class="weapons-v2__top-filter">
      <div class="filter-wrapper">
        <nuxt-link
          :class="{ 'btn-violet': !route.query.team }"
          :to="{
            path: localePath(`/weapons/${route.params.id}`),
            query: route.query.rarity ? { rarity: route.query.rarity } : {},
          }"
          class="btn btn-primary"
        >
          {{ t('all_items_named', { n: t(`filters.weapon.${weapon?.weapon}`) }) }}
        </nuxt-link>
        <nuxt-link
          v-for="team in filters.teams"
          :key="team"
          :class="{ 'btn-violet': route.query.team === team }"
          :to="{
            path: localePath(`/weapons/${route.params.id}`),
            query: { ...route.query, team },
          }"
          class="btn btn-primary"
        >
          <img
            :alt="team"
            :src="`/icons/sides/${team?.toLowerCase().slice(0, -1)}.png`"
          >
          {{ t(`teams.${team}`) }}
        </nuxt-link>
      </div>

      <ui-select
        v-if="filters.rarities_count?.length"
        v-model="rarity"
        :items="filters.rarities_count || []"
        :placeholder="t('all_rarity')"
        clearable
        label-key="name"
        value-key="name"
        @on-change="setFilter('rarity', $event)"
      />
    </div>

    <template v-if="items?.length && !loading">
      <div class="weapons-v2__grid">
        <LazyPagesWeaponComponentsAgentsItemCard
          v-for="item in items"
          :key="item?.market_hash_name"
          :item="item"
          :link="getItemLink({ name: item?.market_hash_name, slug: item?.link })"
        />
      </div>

      <paginate-v3
        v-if="items?.length && !loading && pagesLength > 1"
        :pages-length="pagesLength"
        :total="pagesLength * 50"
        :total-items="50 * page > pagesLength * 50 ? pagesLength * 50 : 50 * page"
        use-query
      />
    </template>

    <div
      v-else-if="loading"
      class="load_period loading-container my54 py54"
    >
      <div class="f fc">
        <i class="i-loading ml10" />
      </div>
    </div>
    <div v-else>
      <ui-no-result class="mxa" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  Item,
  ItemsByField,
  ItemWeaponPageFiltersResult,
} from '~/graphql/generated/schema-types';
import { getImageFromWaxpeer } from '~/utils/get-image-url';

defineProps<{
  weapon: Item & { category: string }
  loading: boolean
  items: ItemsByField[]
  filters: ItemWeaponPageFiltersResult
  pagesLength: number
  title?: string
  subTitle?: string
}>();
const emit = defineEmits(['onPageChange']);

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const localePath = useLocalePath();

const rarity = ref(route.query.rarity || null);

const page = computed(() =>
  route.query.page ? Number.parseInt(route.query.page as string) : 1);

watch(() => page.value, () => {
  emit('onPageChange', page.value);
});

// const weaponTitle = computed(() => {
//   if (props.weapon.category?.toLowerCase() === 'other') {
//     return t(`filters.weapon.${props.weapon?.weapon}`);
//   }
//
//   if (props.weapon?.full_name.toLowerCase().includes('collect')) {
//     return `${t('inspect_all_skins', { name: t(`filters.weapon.${props.weapon?.weapon}`) })}`;
//   }
//
//   return `${t('all_skins', { name: t(`filters.weapon.${props.weapon?.weapon}`) })}`;
// });

function setFilter(name: string, value: string | null) {
  const newQuery = { ...route.query };

  if (value === null || value === newQuery[name]) {
    delete newQuery[name];
  } else {
    newQuery[name] = value;
  }

  router.push({ query: newQuery });
}
</script>

<style lang="scss" scoped>
.weapons-v2 {
  padding-top: 32px;
  padding-bottom: 80px;

  &__top-wrapper {
    display: flex;
    align-items: center;
    gap: 56px;
    margin-bottom: 48px;

    .image-wrapper {
      width: 200px;
      height: 200px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        position: relative;
        z-index: 1;
      }

      &:after {
        content: '\e81f';
        font-family: 'fontello';
        position: absolute;
        inset: 0;
        text-align: center;
        display: block;
        font-size: 15rem;
        line-height: 20rem;
        color: var(--surfaces-outline);
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
        opacity: 0.2;
      }
    }
  }

  &__top-filter {
    &, .filter-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
    }

    &:deep(.cselect) {
      width: max-content;
      min-width: 200px;
      margin-left: auto;

      .form_label {
        font-size: 14px;
        font-weight: 600;
        color: var(--surfaces-on-surface);
      }
    }

    .btn {
      padding: 6.5px 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: normal;
      min-height: unset;
      border-radius: 6px;
      white-space: nowrap;
      flex-shrink: 0;

      &.btn-violet {
        background: var(--accent-secondary);
      }

      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }

  &__info {
    &-title {
      font-size: 28px;
      font-weight: 600;
      line-height: 36px;
      margin-bottom: 20px;
      color: var(--surfaces-on-surface);
    }

    &-desc {
      max-width: 600px;
      font-size: 16px;
      font-weight: 400;
      line-height: 32px;
      color: var(--surfaces-on-surface-variable);

      .btn-link {
        display: none;
        font-size: 16px;
        text-decoration: underline;
        color: var(--surfaces-on-surface);
        padding: 0 0 0 4px;
        position: relative;
        bottom: 2px;
      }
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(201px, 1fr));
    gap: 16px;
  }

  @media (max-width: 768px) {
    &__top-filter {
      flex-wrap: wrap;
      gap: 8px;

      &:deep(.cselect) {
        margin-left: unset;
      }

      .filter-wrapper {
        width: 100%;
        overflow-x: auto;
      }
    }
  }
  @media (max-width: 525px) {
    padding-bottom: 16px;
    &__top-wrapper {
      flex-direction: column;
      gap: 8px;
      margin-bottom: 24px;

      .image-wrapper {
        width: 230px;
        height: 230px;
      }
    }

    &__top-filter {
      &:deep(.cselect) {
        width: 100%;
      }
    }

    &__info {
      &-title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 12px;
      }

      &-desc {
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;

        .btn-link {
          display: inline-block;
          font-size: 14px;
        }
      }
    }

    &__grid {
      gap: 12px;
      grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    }
  }
}
</style>
